import React from 'react';
import { motion } from 'framer-motion';
import './HeroSection.css';

const HeroSection: React.FC = () => {
  return (
    <section id="inicio" className="hero">
      <div className="hero-background">
        <div className="hero-grid"></div>
      </div>
      
      <div className="container">
        <div className="hero-content">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="hero-text"
          >
            <h1 className="hero-title">
              Sua marca sempre online.
              <br />
              <span className="highlight">Mais visitas, mais clientes.</span>
            </h1>
            
            <p className="hero-subtitle">
              A Genesys Sistemas desenvolve sites institucionais, landing pages e catálogos digitais 
              que geram mais leads e aumentam suas vendas. Hospedagem grátis por 1 mês!
            </p>
            
            <div className="hero-stats">
              <div className="stat">
                <span className="stat-number">+400%</span>
                <span className="stat-label">Mais leads qualificados</span>
              </div>
              <div className="stat">
                <span className="stat-number">24/7</span>
                <span className="stat-label">Presença online</span>
              </div>
              <div className="stat">
                <span className="stat-number">100%</span>
                <span className="stat-label">Responsivo</span>
              </div>
            </div>
            
            <div className="hero-cta">
              <a href="#contato" className="btn-primary btn-large">
                🚀 Solicitar Orçamento Agora
              </a>
            </div>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="hero-visual"
          >
            <div className="mockup-container">
              <div className="mockup-screen">
                <div className="mockup-header">
                  <div className="mockup-dots">
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </div>
                <div className="mockup-content">
                  <div className="mockup-bar"></div>
                  <div className="mockup-bar short"></div>
                  <div className="mockup-bar medium"></div>
                  <div className="mockup-image"></div>
                  <div className="mockup-bar"></div>
                  <div className="mockup-bar short"></div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
      
      <div className="hero-scroll">
        <span>Role para descobrir</span>
        <div className="scroll-arrow">↓</div>
      </div>
    </section>
  );
};

export default HeroSection;